<template>
  <div class="basics_example_component">
    <div class="correct">
      <span class="text">正确填涂</span>
      <span class="correct_content content"></span>
    </div>
    <div class="error"> 
      <span class="text">错误填涂</span>
      <span class="error_content content">
        <img src="@/assets/images/error_image.png"  alt="错误填涂">
      </span>
    </div>
  </div>
</template>

<script>
export default {
data() {
  return {
  }
}
}
</script>

<style lang="scss" scoped>
.basics_example_component{
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.correct, .error{
  display: flex;
  align-items: center;
  .text{
  }
  .content{
    margin-left: 10px;
  }
}
.correct{
  .correct_content{
    width: 20px;
    height: 8px;
    background-color: #000;
  }
}
.error{
    margin-left: 14px;
}
</style>